export default __webpack_public_path__ + "static/media/cross_icon_black.a637cd78.svg";